import "../../../../styles/page/order.scss";

import {TitleTab, TitleTabs} from "../../../common/components/TitleTabs.jsx";

import CampaignCard from "./CampaignCard.jsx";
import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ShoppingCart from "../../components/order/ShoppingCart.jsx";
import moment from "moment";
import {scssVariables} from "../../../common/util/config.jsx";
import {withRouter} from "react-router-dom";

class CampaignPage extends React.PureComponent {
    constructor(props){
        super(props);
        
        this.createList = this.createList.bind(this);
        this.calculateProductDisplayHeight = this.calculateProductDisplayHeight.bind(this);
        this.calculateShoppingCartHeight = this.calculateShoppingCartHeight.bind(this);
        this.calculateProductDisplayWidth = this.calculateProductDisplayWidth.bind(this);
        this.loadMoreSearchResaults = this.loadMoreSearchResaults.bind(this);
    }
    
    UNSAFE_componentWillMount() {
        const {
            activeOrder,
            getCampaigns,
            initiateCurrentOrder,
            getOrderFeeLimits,
            getOrderVolumeDiscounts,
        } = this.props;
        getCampaigns();
        getOrderFeeLimits();
        getOrderVolumeDiscounts();
        if( activeOrder && activeOrder.loading==false && activeOrder.shipmentId==null) {
            initiateCurrentOrder();
        }
    }

    createList() {
        const {
            localization,
            productLists,
            addRemoveProductToTemporaryOrder,
            deviceType,
            activeOrder,
            productView,
            history,
            setModal,
        } = this.props;
        const productDisplayWidth = this.calculateProductDisplayWidth();
        const nodePrd = [];
        for(let i=0; i<productLists.campaigns.length; i++) {
            if( productLists.campaigns[i].campaignId>=0){
                nodePrd.push(
                    <CampaignCard
                        key={productLists.campaigns[i].campaignId}
                        campaignId={productLists.campaigns[i].campaignId}
                        localization={localization}
                        productView={productView}
                        addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                        width={productDisplayWidth}
                        deviceType={deviceType}
                        activeOrder={activeOrder}
                        labelHeader="Featured"
                        labelName={productLists.campaigns[i].campaignNameAlias}
                        campaignPeriod = {`  (${moment(productLists.campaigns[i].startDateRetailer).format("DD.MM.YYYY")} - ${moment(productLists.campaigns[i].endDateRetailer).format("DD.MM.YYYY")})`}
                        products={productLists.campaigns[i].campaignProducts}
                        history={history}
                        setModal={setModal}
                    />
                );
            }
        }
        return nodePrd;
    }

    calculateProductDisplayHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;

        if( deviceType==="xs" ) {
            //shopping cart in menu form
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        } else {
            //title tab height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.titleTabHeight);
            //searchbar height
            productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;
            productDisplayHeight -= parseInt(scssVariables.menuHeightWithBorder);
        }
        //product display padding
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }
    calculateProductDisplayWidth() {
        const {
            deviceType,
            width,
        } = this.props;

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        let productDisplayWidth = width;
        if( deviceType==="xs" ) {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        } else {
            //page padding
            productDisplayWidth -= parseInt(scssVariables[`${deviceType}ContentPadding`]);//no padding on the right side(Attached to it)
            //page padding
            productDisplayWidth -= parseInt(isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth);
            //product display padding
            productDisplayWidth -= parseInt(scssVariables.cardMargin)*2;
        }

        return productDisplayWidth;
    }
    calculateShoppingCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    loadMoreSearchResaults() {
        const {
            deviceType,
            loadMoreSearchedProducts,
        } = this.props;
        const productDisplayHeight = this.calculateProductDisplayHeight();
        const rowsToLoad = (Math.floor(productDisplayHeight/parseInt(scssVariables.productItemHeight))+2);
        // rowsToLoad * itemsPerRow
        switch(deviceType){
        case "xs":
        case "sm":
            loadMoreSearchedProducts( rowsToLoad*2 );
            break;
        case "md":
            loadMoreSearchedProducts( rowsToLoad*4 );
            break;
        case "lg":
            loadMoreSearchedProducts( rowsToLoad*6 );
            break;
        default:
            loadMoreSearchedProducts( rowsToLoad*8 );
            break;
        }
    }


    render(){
        const {
            deviceType,
            localization,
            activeOrder,
            addRemoveProductToTemporaryOrder,
            height,
            width,
            submitOrder,
            deliveryDates,
            setActiveOrder,
            moveUnconfirmedLinesToNextOrder,
            setModal,
            setDropDown,
            orderFeeLimits,
            orderVolumeDiscounts,
            newSeasonDistrDates,
            showFreshFood,
        } = this.props;
        const shoppingCartHeight = this.calculateShoppingCartHeight();

        const isTinyDevice = deviceType=="xs" || deviceType=="sm";

        return deviceType=="xs" ? (
            <ContentWrapper height={height}>
                <div className="my-list-left-backgorund" >
                    {this.createList()}
                    <ShoppingCart
                        localization={localization}
                        height={shoppingCartHeight}
                        deviceType={deviceType}
                        width={width}
                        activeOrder={activeOrder}
                        addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                        submitOrder={submitOrder}
                        deliveryDates={deliveryDates}
                        setActiveOrder={setActiveOrder}
                        moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder}
                        setModal={setModal}
                        setDropDown={setDropDown}
                        orderFeeLimits={orderFeeLimits}
                        orderVolumeDiscounts={orderVolumeDiscounts}
                        newSeasonDistrDates={newSeasonDistrDates}
                    />
                </div>
            </ContentWrapper>
        ) : (
            <ContentWrapper height={height} paddingRight={false}>
                <div style={{display:"flex", height:"100%"}} >
                    <div className="my-list-left-backgorund" >
                        <TitleTabs>
                            <TitleTab label={localization.text("order","TitleTab","Products")} url={"/order/products"} deviceType={deviceType} />
                            <TitleTab label={localization.text("order","TitleTab","Campaigns")} url={"/order/campaigns"} deviceType={deviceType} />        
                            <TitleTab label={localization.text("order","TitleTab","List")} url={"/order/lists"} deviceType={deviceType} />
                            { showFreshFood && (
                                <TitleTab label={localization.text("order","TitleTab","FreshFoodTemplate")} url={"/order/freshfoodTemplate"} deviceType={deviceType} />
                            )} 
                        </TitleTabs>
                        {this.createList()}
                    </div>
                    <div style={{height:"100%", flex: `0 0 ${isTinyDevice ? scssVariables.shoppingCartWidthTiny : scssVariables.shoppingCartWidth}`}} >
                        <ShoppingCart
                            localization={localization}
                            height={shoppingCartHeight}
                            width={width}
                            deviceType={deviceType}
                            activeOrder={activeOrder}
                            addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                            submitOrder={submitOrder}
                            deliveryDates={deliveryDates}
                            setActiveOrder={setActiveOrder}
                            moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder}
                            setModal={setModal}
                            setDropDown={setDropDown}
                            orderFeeLimits={orderFeeLimits}
                            orderVolumeDiscounts={orderVolumeDiscounts}
                            newSeasonDistrDates={newSeasonDistrDates}
                        />
                    </div>
                </div>
            </ContentWrapper>
        );
    }
}

CampaignPage.propTypes = {
    //Required
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    activeOrder: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    submitOrder: PropTypes.func.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    setActiveOrder: PropTypes.func.isRequired,
    productLists: PropTypes.object.isRequired,
    getCampaigns: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    initiateCurrentOrder: PropTypes.func.isRequired,
    moveUnconfirmedLinesToNextOrder: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    getOrderFeeLimits: PropTypes.func.isRequired,
    orderFeeLimits: PropTypes.array.isRequired,
    getOrderVolumeDiscounts: PropTypes.func.isRequired,
    orderVolumeDiscounts: PropTypes.array.isRequired,
    newSeasonDistrDates: PropTypes.array.isRequired,
    showFreshFood: PropTypes.bool.isRequired,
};

export default withRouter(CampaignPage);